import { getEnv } from '@config';

const { country } = getEnv();

const causesCL = {
  'recaudacion-installment-credit': 'al Crédito',
  'recaudacion-credit-line': 'a la Linea de crédito',
};

const causesPE = {
  '': 'al prestamo comercial',
};

export const CAUSES = {
  cl: causesCL,
  pe: causesPE,
}[country];
